import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_LT.json';
import exercises from './YOGA_EXERCISES_LT.json';
import recipes from './YOGA_RECIPES_LT.json';

export const YOGA_DATA_LT: ServiceData = {
  articles,
  exercises,
  recipes,
};
